<template>
  <b-modal
    id="modal-home-video"
    ref="modal-home-video"
    v-model="modalShow"
    size="lg"
    centered
    hide-header
    hide-footer
  >
    <b-button-close class="close-button" @click="closeModal"></b-button-close>
    <b-embed
      v-if="modalShow"
      ref="embed-home-video"
      type="iframe"
      src="https://www.youtube.com/embed/UaX0DPXC1dU"
      allowfullscreen
    ></b-embed>
  </b-modal>
</template>


<script>
import { mapState } from "vuex";

export default {
  name: "home-video",
  data() {
    return {
      modalShow: false,
    };
  },
  computed: {
    ...mapState({
      home_video_displayed: state => state.siteconf.home_video_displayed,
    }),
  },
  mounted() {
    if (!this.home_video_displayed) {
      // Mostramos el vídeo y guardamos estado para no volver a mostrar
      this.modalShow = true;
      this.$store.commit("siteconf/MUTATE_HOME_VIDEO_DISPLAYED", true);
    }
  },
  methods: {
    closeModal() {
      this.$refs["modal-home-video"].hide();
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .modal .modal-dialog .modal-content .modal-body .close-button {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
